import s from './DealCheckbox.scss'
import { fromConstantPropertyToSelectValue } from 'utils/serializers'
import { timezoneDate } from 'utils/helpers'

const DealCheckbox = ({ deal, contact, toggleContactDeal }) => {
  return (
    <div className={s.deal}>
      <input
        type="checkbox"
        id={deal.id}
        checked={deal.isChecked}
        onChange={() => toggleContactDeal(deal, contact)}
      />
      <label htmlFor={deal.id}>{deal.name}</label>
      <div>
        <span className={s.dealInfo}>{deal.status.name}</span>|
        <span className={s.dealInfo}>
          {fromConstantPropertyToSelectValue(deal.proposalStatus, 'ProposalStatus')?.label}
        </span>
        -
        {deal.proposalSentDate && (
          <span className={s.dealInfo}>{`sent: ${timezoneDate(deal.proposalSentDate)}`}</span>
        )}
        {deal.readDate && (
          <span className={s.dealInfo}>{`- received: ${timezoneDate(deal.readDate)}`}</span>
        )}
        |
        <span className={s.dealInfo}>
          {deal.followUpDate
            ? `Follow-up Date: ${timezoneDate(deal.followUpDate)}`
            : `Bid Due Date: ${timezoneDate(deal.dueDate)}`}
        </span>
      </div>
    </div>
  )
}

export default DealCheckbox
